export default __webpack_public_path__ + "static/media/Report (1).cb57f02b.png";